// MARK: NPM Modules
import React from "react";
import styled from "styled-components";

// MARK: Styled Components
interface MailContainerProps {
  margintop: number;
}
const MailContainer = styled(({ ...rest }) => (
  <a {...rest} rel="" href={"mailto:inquiries@delasign.com"} />
))<MailContainerProps>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-conntent: flex-start;
  width: 100%;
  margin-top: ${({ margintop }) => margintop}px;
`;

export default MailContainer;
